export const SET_SESSION = "SET_SESSION";
export const SET_APP_LOADING = "SET_APP_LOADING";
export const TOGGLE_SETTINGS_DRAWER = "TOGGLE_SETTINGS_DRAWER";
export const LOAD_NOTES = "LOAD_NOTES";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const GET_NOTE_BY_ID = "GET_NOTE_BY_ID";
export const SET_NOTE_TO_EDIT = "SET_NOTE_TO_EDIT";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const SET_MODAL_META = "SET_MODAL_META";
export const SET_UPLOADING_DATA = "SET_UPLOADING_DATA";
export const UPDATE_UPLOAD_NOTE = "UPDATE_UPLOAD_NOTE";
export const SET_ACTIVE_COLLECTION = "SET_ACTIVE_COLLECTION";
export const FETCH_STATS = "FETCH_STATS";
export const LOGOUT = "LOGOUT";
export const SET_QUICK_ADD_MODAL_META = "SET_QUICK_ADD_MODAL_META";
export const SET_KEY = "SET_KEY";
export const FETCH_CHAINS = "FETCH_CHAINS";
export const TOGGLE_SELECTED_ITEMS = "TOGGLE_SELECTED_ITEMS";
